import React from "react";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import { makeStyles } from "@material-ui/core/styles";
import clsx from "clsx";
import { TestRequestFlag } from "./RequestFlag";
import RequestFlagIcon from "./RequestFlagIcon";
import { tesaDarkGrey } from "../../styles/colors";
import StyledTooltip from "../Wrapper/StyledTooltip";

export const GUTTER_SPACING_DEFAULT = 2;

const REQUEST_FLAG_TOOLTIPS_MAPPING: {
  [F in TestRequestFlag]: string;
} = {
  DEADLINE_MAY_NOT_BE_MET: "Conflict between Deadline Date and Estimated Finishing Date",
  DUPLICATED: "Duplicated Test Request",
  HISTORICAL: "Historical Test Request",
  OVERDUE: "Estimated Finishing Date overdue",
  SPECIFICATION_NEEDED: "",
  WAITING_FOR_MATERIAL: "Waiting for Material (Substrates/Products)",
};

const REQUEST_FLAGS_ORDERED = [
  "DEADLINE_MAY_NOT_BE_MET",
  "OVERDUE",
  "WAITING_FOR_MATERIAL",
  "DUPLICATED",
  "HISTORICAL",
] as const;

const useStyles = makeStyles((theme) => ({
  colorDark: {
    color: tesaDarkGrey,
  },
  noMinWidth: {
    minWidth: 0,
  },
  listHorizontal: (props: RequestFlagIconListProps) => ({
    display: "inline-flex",

    "& > * + *": {
      marginLeft: theme.spacing(props.gutterSpacing ?? GUTTER_SPACING_DEFAULT),
    },
  }),
  noPadding: {
    padding: 0,
  },
}));

export interface RequestFlagIconListProps {
  flags: TestRequestFlag[] | undefined;
  gutterSpacing?: number;
}

const RequestFlagIconList: React.FC<RequestFlagIconListProps> = (props) => {
  const { flags } = props;
  const classes = useStyles(props);
  const flagsOrdered = flags?.length ? REQUEST_FLAGS_ORDERED.filter((flag) => flags.includes(flag)) : null;

  if (!flagsOrdered) {
    return null;
  }

  return (
    <List className={classes.listHorizontal} disablePadding>
      {flagsOrdered.map((flag) => (
        <StyledTooltip title={REQUEST_FLAG_TOOLTIPS_MAPPING[flag]} key={flag}>
          <ListItem classes={{ root: classes.noPadding }} disableGutters key={flag}>
            <ListItemIcon classes={{ root: clsx(classes.colorDark, classes.noMinWidth) }}>
              <RequestFlagIcon flag={flag} />
            </ListItemIcon>
          </ListItem>
        </StyledTooltip>
      ))}
    </List>
  );
};

export default RequestFlagIconList;
